const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Convert "7d" / "30d" / "90d" → number of days for the API
function rangeToDays(range) {
  const map = { "7d": 7, "30d": 30, "90d": 90 };
  return map[range] ?? 30;
}

/**
 * Fetches analytics dashboard data.
 *
 * @param {string}      range       - "7d" | "30d" | "90d"
 * @param {string|null} patientId   - owner_id of a specific patient, or null for all
 * @param {AbortSignal} signal
 */
export async function fetchAnalyticsDashboard(range = "30d", patientId = null, signal) {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("auth token missing");

  const params = new URLSearchParams({
    limit: 50,
    skip: 0,
    days: rangeToDays(range),
  });

  // Only filter by patient when one is explicitly selected
  if (patientId) params.append("patient_id", patientId);

  const res = await fetch(
    `${BASE_URL}/api/future/health/analytics/dashboard?${params}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal,
    }
  );

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `Request failed with status ${res.status}`);
  }

  const json = await res.json();
  if (json.status !== "success") throw new Error(json.message || "Unknown API error");

  return json.data;
}